import { render, staticRenderFns } from "./StoryblokContactForm.vue?vue&type=template&id=43c273b0&"
import script from "./StoryblokContactForm.vue?vue&type=script&lang=ts&"
export * from "./StoryblokContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports